// Vendors
import React from 'react';
// Components
import { DownloadAppModal } from 'components/download-app-modal/download-app-modal.component';
// Configurations
import { getDownloadAppSKConfigurations } from './configurations/download-app-sk-modal.configurations';
// Types
import type { DownloadAppSKModalPropsType } from './types/download-app-sk-modal-props.type';

export const DownloadAppSKModalComponent = ({
  isOpen,
  onClose,
  ...rest
}: DownloadAppSKModalPropsType): React.ReactElement => (
  <DownloadAppModal
    {...getDownloadAppSKConfigurations({ ...rest, handleCloseModal: onClose, isModalOpen: isOpen })}
  />
);
